import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import {memo} from 'react'

import {PlaceIdList} from '../../../plugins/plugins.types'
import Plugin from '../../common/Plugin/Plugin'

import styles from './ChangesPage.css'

function ChangesPageHeader() {
  return (
    <div className={styles.header}>
      <H1 className={styles.heading}>{`Changes`}</H1>
      <Plugin placeId={PlaceIdList.SAKURA_BEFORE_CONTENT} />
    </div>
  )
}

export default memo<{}>(ChangesPageHeader)
